import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Hidden } from '@material-ui/core'
import Button from 'components/theme/Button'
import { withRouter } from 'react-router-dom'
import {
  /* saveTemplate, */ createTemplate,
  updateTemplate,
} from 'actions/template'

export default withRouter(
  connect(
    (state) => ({
      disabled: !state.email.templateName.value.length,
      templateID: state.email.templateID,
    }),
    (dispatch) =>
      bindActionCreators(
        { /* saveTemplate, */ createTemplate, updateTemplate },
        dispatch,
      ),
  )(({ history, templateID, createTemplate, updateTemplate, disabled }) => {
    const button = (size) => (
      <Button
        size={size}
        disabled={disabled}
        variant="contained"
        color="secondary"
        onClick={() => {
          if (templateID === 'new') {
            createTemplate().then((payload) => {
              if (payload.id) {
                history.replace(`/templates/${payload.id}`)
              }
            })
          } else {
            updateTemplate()
          }
        }}
      >
        {templateID === 'new' ? 'CREATE' : 'UPDATE'}
      </Button>
    )

    return (
      <Fragment>
        <Hidden smDown>{button('medium')}</Hidden>
        <Hidden mdUp>{button('small')}</Hidden>
      </Fragment>
    )
  }),
)
